
import React,{useState} from 'react';

function Todo() {
    const [tasks, setTasks] = useState([]);
    const  [task, setTask] = useState('');
      const  handleClick=()=>{
      setTasks([...tasks, task]);//new task is added in old array
      alert("task added successfully")
      setTask('');
      }
      const deletetask=(t)=>{
        setTasks(tasks.filter((item)=>item!==t))
      }
  return (
      <div className="container-fe">
              <h2>ALL LIST</h2>
        <ul>  
          {
            tasks.map((item,index)=>(
            <li key={index}> {item} <button onClick={()=>deletetask(item)}>x</button></li>
            ))
         } 
        </ul>
              <div className="container">
                 <button type="button" className="search"><h4>ENTER THE TASK</h4></button>
                 <input type="text"className="todo" placeholder="write"value={task} onChange={(e)=>setTask(e.target.value)}/>
                 <button type="button" className ="addbutton"onClick={handleClick}><h4><strong>Add Task</strong></h4></button>  
               </div>
      </div>
    );
}
    export default Todo;